(function () {
    'use strict';

    angular.module('doclr.werkschema', [
        'doclr.components.notification',
        'doclr.components.validations',
        'doclr.resources.api',
        'ui.bootstrap',
        'ui.router'
    ])
        .config(['$stateProvider', function ($stateProvider) {
            $stateProvider
                .state('werkschema', {
                    url: '/werkschema',
                    resolve: {
                        werkschemaOverzichtModel: function (Werkschema, praktijkContext) {
                            return Werkschema.getLijst(praktijkContext.id).then(function (werkschemas) {
                                return {
                                    werkschemas: werkschemas,
                                    reload: function () {
                                        var that = this;
                                        return Werkschema.getLijst(praktijkContext.id).then(function (werkschemas) {
                                            that.werkschemas = werkschemas;
                                        });
                                    }
                                };
                            });
                        }
                    },
                    views: {
                        '': {
                            templateUrl: '/partials/components/page.with.sidebar.html'
                        },
                        'sidebar@werkschema': {
                            templateUrl: '/partials/werkschema/werkschema.sidebar.html',
                            controller: function ($scope, $state, $uibModal, notificationService, werkschemaOverzichtModel) {
                                $scope.werkschemaOverzichtModel = werkschemaOverzichtModel;

                                $scope.goToDetail = function (werkschemaId) {
                                    $state.go('werkschema.detail', {werkschemaId: encodeURIComponent(werkschemaId)});
                                };

                                $scope.createNew = function () {
                                    var modalInstance = $uibModal.open({
                                        templateUrl: '/partials/werkschema/werkschema.nieuw.html',
                                        resolve: {
                                            agendas: function (AgendaOverzicht, praktijkContext) {
                                                return AgendaOverzicht.get(praktijkContext.id);
                                            }
                                        },
                                        controller: function ($scope, agendas) {
                                            $scope.title = doclrVertaal.instant('js.werschema.newSchedule');
                                            $scope.form = {
                                                agendas: agendas,
                                                selectedAgenda: agendas[0],
                                                vanaf: moment().format('YYYY-MM-DD')
                                            };
                                        }
                                    });

                                    modalInstance.result.then(function (form) {
                                        form.selectedAgenda.maakWerkschema(form.vanaf)
                                            .then(function (response) {
                                                notificationService.showSuccess(doclrVertaal.instant('js.werschema.showSucces'));
                                                werkschemaOverzichtModel.reload();
                                                $state.go('werkschema.detail', {werkschemaId: encodeURIComponent(response.data.id)});
                                            });
                                    });
                                };

                                $scope.isActiefWerkschema = function (werkschema) {
                                    return decodeURIComponent($state.params.werkschemaId) === werkschema.id;
                                };

                                $scope.hasExpiredWerkschemas = function hasExpiredWerkschemas(werkschemas) {
                                    return _.some(werkschemas, function (werkschema) {
                                        return moment(werkschema.vanaf).isBefore(moment()) && moment(werkschema.tot).isBefore(moment());
                                    });
                                };
                            }
                        }
                    }
                })
                .state('werkschema.default', {
                    onEnter: function ($state, werkschemaOverzichtModel, userContext) {
                        var werkschemas = werkschemaOverzichtModel.werkschemas;
                        if (werkschemas.length > 0) {
                            var defaultAgendaId = userContext.defaultAgendaId;
                            var defaultAgenda = werkschemas.getAgendaById(defaultAgendaId) || werkschemas[0];
                            if (defaultAgenda.werkschemas.length > 0) {
                                $state.go('werkschema.detail', {werkschemaId: encodeURIComponent(defaultAgenda.werkschemas[0].id)});
                            }
                        }
                    }
                })
                .state('werkschema.detail', {
                    url: '/:werkschemaId',
                    resolve: {
                        werkschemas: function (Werkschema, praktijkContext) {
                            return Werkschema.getLijst(praktijkContext.id).then((werkschemas) => {
                                return werkschemas;
                            });
                        },
                        werkschemaModel: function ($stateParams, Werkschema, werkschemaToAgendaEventsFilter, werkschemaOverzichtModel) {
                            return Werkschema.load(decodeURIComponent($stateParams.werkschemaId))
                                .then(function (initialWerkschema) {
                                    return {
                                        werkschema: initialWerkschema,
                                        weekIndex: 0,
                                        agendaEvents: werkschemaToAgendaEventsFilter(initialWerkschema, 0),
                                        verwijderBeschikbaarheid: function (beschikbaarheid) {
                                            this.werkschema.weken[this.weekIndex].splice(
                                                this.werkschema.weken[this.weekIndex].indexOf(beschikbaarheid),
                                                1);
                                        },
                                        save: function () {
                                            return this.saveAndGoToWeek(this.weekIndex);
                                        },
                                        saveAndGoToWeek: function (weekIndex) {
                                            var that = this;
                                            return this.werkschema.save()
                                                .then(function (nieuwWerkschema) {
                                                    that.werkschema = nieuwWerkschema;
                                                    that.weekIndex = weekIndex;
                                                    that.agendaEvents = werkschemaToAgendaEventsFilter(nieuwWerkschema, weekIndex);
                                                    return nieuwWerkschema;
                                                })
                                                .then(function () {
                                                    return werkschemaOverzichtModel.reload();
                                                });
                                        },
                                        goToWeek: function (weekIndex) {
                                            this.weekIndex = weekIndex;
                                            this.agendaEvents = werkschemaToAgendaEventsFilter(this.werkschema, weekIndex);
                                        }
                                    };
                                });
                        },
                        beschikbaarheidTypes: function (BeschikbaarheidTypes, praktijkContext) {
                            return BeschikbaarheidTypes.getTypes(praktijkContext.id);
                        }
                    },
                    views: {
                        'content@werkschema': {
                            templateUrl: '/partials/werkschema/werkschema.detail.html',
                            controller: 'WerkschemaController'
                        }
                    }
                })
                .state('werkschema.detail.beschikbaarheid', {
                    params: {
                        beschikbaarheidToEdit: null,
                        intentie: null
                    },
                    resolve: {
                        beschikbaarheidTypes: function (BeschikbaarheidTypes, praktijkContext) {
                            return BeschikbaarheidTypes.getTypes(praktijkContext.id);
                        },
                        beschikbaarheidToEdit: function ($stateParams) {
                            return $stateParams.beschikbaarheidToEdit;
                        },
                        intentie: function ($stateParams) {
                            return $stateParams.intentie;
                        }
                    },
                    onEnter: function ($uibModal, $state, werkschemaModel, beschikbaarheidTypes, beschikbaarheidToEdit, intentie) {
                        var modalInstance = $uibModal.open({
                            templateUrl: '/partials/werkschema/beschikbaarheid.html',
                            controller: function ($scope, notificationService) {
                                function bepaalAfspraakDuur(beschikbaarheid) {
                                    var vanUur = moment(beschikbaarheid.van, 'HH:mm');
                                    var totUur = moment(beschikbaarheid.tot, 'HH:mm');
                                    return totUur.diff(vanUur, 'minutes');
                                }

                                $scope.nieuw = intentie === 'nieuw';
                                $scope.form = {};
                                $scope.form.beschikbaarheid = angular.copy(beschikbaarheidToEdit);
                                $scope.form.types = beschikbaarheidTypes.filter(type => type.event_type == 'beschikbaarheid');
                                // function (x) {
                                //     return x.event_type !== 'afwezigheid' && ;
                                // });
                                $scope.form.selectedType = beschikbaarheidTypes.findTypeVoorId(beschikbaarheidToEdit.typeId);
                                $scope.form.beschikbaarheid.afspraakDuur = bepaalAfspraakDuur(beschikbaarheidToEdit);
                                $scope.form.beschikbaarheid.aantalAfspraken = 1;

                                $scope.form.weekdag = moment().weekday(beschikbaarheidToEdit.weekdag - 1).format('dddd');

                                if ($scope.nieuw) {
                                    $scope.form.availabilityReleaseStrategy = AvailabilityReleaseStrategy.createNew();
                                } else {
                                    $scope.form.availabilityReleaseStrategy = AvailabilityReleaseStrategy.createFromEvent(
                                        beschikbaarheidToEdit.releaseNumberOfDaysBefore,
                                        beschikbaarheidToEdit.releaseInOrderNumber,
                                        beschikbaarheidToEdit.releaseInOrderGroup
                                    )
                                }

                                $scope.form.availableTypes = $scope.form.types.filter(type => type.isActive || beschikbaarheidToEdit.typeId === type.id);

                                $scope.$watch('form.selectedType', function (newValue, oldValue) {
                                    if (newValue === oldValue) {
                                        return;
                                    }
                                    $scope.form.beschikbaarheid.afspraakDuur = newValue.duur;
                                    if (newValue.zichtbaar_voor_patient === 'nee') {
                                        $scope.form.availabilityReleaseStrategy.reset();
                                    }
                                });

                                $scope.$watchGroup(['form.beschikbaarheid.afspraakDuur', 'form.beschikbaarheid.aantalAfspraken', 'form.beschikbaarheid.van'], function (newValue, oldValue) {
                                    if (newValue === oldValue) {
                                        return;
                                    }

                                    function isMetAfspraakMogelijkheden() {
                                        return $scope.form.beschikbaarheid && $scope.form.selectedType && $scope.form.selectedType.met_afspraakmogelijkheden;
                                    }

                                    function calculateTotUur(offsetMinuten) {
                                        var vanUur = moment($scope.form.beschikbaarheid.van, 'HH:mm');
                                        var totNieuw = vanUur.add(offsetMinuten, 'minutes');
                                        return totNieuw.format('HH:mm');
                                    }

                                    function getOffsetMinuten() {
                                        if (isMetAfspraakMogelijkheden()) {
                                            return $scope.form.beschikbaarheid.afspraakDuur * $scope.form.beschikbaarheid.aantalAfspraken;
                                        }

                                        return $scope.form.beschikbaarheid.afspraakDuur;
                                    }

                                    function maxAfspraken() {
                                        if (isMetAfspraakMogelijkheden()) {
                                            const vanUur = moment($scope.form.beschikbaarheid.van, 'HH:mm');
                                            const maxUur = moment('23:59', 'HH:mm');
                                            const minutesBetween = moment.duration(maxUur.diff(vanUur)).asMinutes();
                                            return Math.floor(minutesBetween / $scope.form.beschikbaarheid.afspraakDuur);
                                        }
                                        return 0;
                                    }

                                    const maxAantalAfspraken = maxAfspraken();
                                    if (isMetAfspraakMogelijkheden() && $scope.form.beschikbaarheid.aantalAfspraken > maxAantalAfspraken) {
                                        notificationService.showWarning(doclrVertaal.instant('js.werschema.maxAantalAfsprakenBereikt'));
                                        $scope.form.beschikbaarheid.aantalAfspraken = maxAantalAfspraken;
                                    }

                                    $scope.form.beschikbaarheid.tot = calculateTotUur(getOffsetMinuten());

                                });

                                $scope.bevestig = function bevestig() {
                                    var form = $scope.form;

                                    angular.copy(form.beschikbaarheid, beschikbaarheidToEdit);
                                    beschikbaarheidToEdit.type = form.selectedType.naam;
                                    beschikbaarheidToEdit.typeId = form.selectedType.id;
                                    beschikbaarheidToEdit.kleur = form.selectedType.kleur;
                                    beschikbaarheidToEdit.releaseNumberOfDaysBefore = $scope.form.availabilityReleaseStrategy.timeBoundRelease.getReleaseNumberOfDaysBefore();
                                    beschikbaarheidToEdit.releaseInOrderNumber = $scope.form.availabilityReleaseStrategy.inOrderRelease.getReleaseInOrderNumber();
                                    beschikbaarheidToEdit.releaseInOrderGroup = $scope.form.availabilityReleaseStrategy.inOrderRelease.getReleaseInOrderGroup();

                                    if (!form.selectedType.met_afspraakmogelijkheden) {
                                        delete beschikbaarheidToEdit.afspraakDuur;
                                        delete beschikbaarheidToEdit.aantalAfspraken;
                                    }

                                    if (intentie === 'nieuw') {
                                        werkschemaModel.werkschema.weken[werkschemaModel.weekIndex].push(beschikbaarheidToEdit);
                                    }

                                    werkschemaModel.save().then(function () {
                                        notificationService.showSuccess(doclrVertaal.instant('js.werschema.showSucces.updateSchedule'));
                                        modalInstance.close();
                                    });
                                };

                                $scope.annuleer = function annuleer() {
                                    modalInstance.dismiss();
                                };

                                $scope.verwijder = function verwijder() {
                                    werkschemaModel.verwijderBeschikbaarheid(beschikbaarheidToEdit);
                                    werkschemaModel.save().then(function () {
                                        notificationService.showSuccess(doclrVertaal.instant('js.werschema.showSucces.removeAvailability'));
                                        modalInstance.close();
                                    });
                                };
                            }
                        });

                        modalInstance.result.finally(function () {
                            $state.go('^');
                        });
                    }
                });

        }])
        .controller('WerkschemaController', function ($scope, $state, $timeout, $uibModal, notificationService,
                                                      werkschemaToAgendaEventsFilter, alsWeekdagFilter,
                                                      werkschemaOverzichtModel, werkschemas, werkschemaModel, beschikbaarheidTypes) {
            function openModalConfirmantionWindow(options) {
                return $uibModal.open({
                    templateUrl: '/partials/components/confirmmodal.html',
                    controller: function ($scope) {
                        $scope.confirmmodal = options;
                    }
                });
            }

            $scope.oldVanaf = werkschemaModel.werkschema.vanaf;

            $scope.werkschemaModel = werkschemaModel;

            $scope.werkschemas = werkschemas;

            $scope.beschikbaarheidTypes = beschikbaarheidTypes;

            $scope.copyDag = function (column) {
                var copyModal = $uibModal.open({
                    templateUrl: '/partials/werkschema/werkschema.kopieer.dag.html',
                    resolve: {
                        werkschemas: () => {
                            return $scope.werkschemas;
                        }
                    },
                    controller: ($scope, $filter, notificationService, werkschemas) => {
                        $scope.agendas = [];
                        $scope.werkschemas = [];
                        $scope.kopieerDagen = [];
                        $scope.form = {
                            selectedAgenda: null,
                            selectedWerkschema: null,
                            selectedDay: null
                        };

                        $scope.initializeAgendaDropdown = (currentAgendaId) => {
                            $scope.agendas = [];
                            angular.forEach(werkschemas, (agenda) => {
                                if (agenda.werkschemas) {
                                    $scope.agendas.push({
                                        'name': agenda.naam,
                                        'id': agenda.uuid
                                    });
                                }
                            });
                            if (currentAgendaId) {
                                $scope.form.selectedAgenda = $scope.agendas.filter(x => x.id === currentAgendaId)[0]
                            } else {
                                if ($scope.agendas.length > 0) {
                                    $scope.form.selectedAgenda = $scope.agendas[0];
                                }
                            }
                        };

                        $scope.initializeWerkschemasDropdown = (currentWerkschemaId) => {
                            $scope.werkschemas = [];

                            let currentAgenda = werkschemas.find(obj => {
                                return obj.uuid === $scope.form.selectedAgenda.id;
                            });

                            if (currentAgenda.werkschemas) {
                                angular.forEach(currentAgenda.werkschemas, (schema) => {
                                    $scope.werkschemas.push({
                                        'id': schema.id.split('/').pop(),
                                        'vanaf': moment(schema.vanaf).format('DD-MM-YYYY'),
                                        'vanaf_full': schema.vanaf
                                    });
                                });
                            }


                            if (currentWerkschemaId) {
                                $scope.form.selectedWerkschema = $scope.werkschemas.filter(x => x.id === currentWerkschemaId)[0];
                            } else {
                                if ($scope.werkschemas.length > 0) {
                                    $scope.form.selectedWerkschema = $scope.werkschemas[0];
                                }
                            }


                        };
                        $scope.initializeDayDropdown = () => {
                            $scope.kopieerDagen = [];
                            angular.forEach([1, 2, 3, 4, 5, 6, 7], (dag) => {
                                $scope.kopieerDagen.push({
                                    'label': $filter('alsWeekdag')(dag),
                                    'value': dag
                                });
                            });
                            $scope.form.selectedDay = $scope.kopieerDagen[column.header];
                        };


                        const idParts = werkschemaModel.werkschema.id.split('/');
                        let currentAgendaId = idParts[idParts.length - 3];
                        let currentWerkschemaId = idParts[idParts.length - 1];
                        $scope.initializeAgendaDropdown(currentAgendaId);
                        $scope.initializeDayDropdown();
                        $scope.initializeWerkschemasDropdown(currentWerkschemaId);

                        $scope.copyDay = () => {
                            let dagVan = column.header;
                            let dagNaar = $scope.form.selectedDay.value;
                            let werkschemaVan = idParts.pop();
                            let werkschemaNaar = $scope.form.selectedWerkschema.id;

                            werkschemaModel.werkschema.copyDag(dagVan, dagNaar, werkschemaVan, werkschemaNaar)
                                .then(() => {
                                    notificationService.showSuccess(doclrVertaal.instant('werkschema.kopieer.dag.success'));
                                    $state.reload();
                                    copyModal.dismiss();
                                });
                        };
                    }
                });
            };

            $scope.deleteDag = function (column) {
                var modalInstance = openModalConfirmantionWindow({
                    title: doclrVertaal.instant('werkschema.verwijder.dag.titel'),
                    question: doclrVertaal.instant('werkschema.verwijder.dag.message')
                });

                modalInstance.result.then(function () {
                    werkschemaModel.werkschema.deleteDag(column.header)
                        .then(function () {
                                notificationService.showSuccess(doclrVertaal.instant('werkschema.verwijder.dag.success'));
                                $state.reload();
                                modalInstance.dismiss();
                            }
                        );
                });
            };

            $scope.getTooltip = function (column) {
                return `<b>${column.header}</b>`;
            };

            $scope.updateVanaf = function () {
                var oldDate = moment($scope.oldVanaf, 'YYYY-MM-DD');
                var newDate = moment(werkschemaModel.werkschema.vanaf, 'YYYY-MM-DD');

                if (oldDate.isValid() && newDate.isValid() && oldDate.isSame(newDate)) {
                    return;
                }

                $scope.oldVanaf = werkschemaModel.werkschema.vanaf;

                if (moment(werkschemaModel.werkschema.vanaf, 'YYYY-MM-DD').isValid()) {
                    werkschemaModel.save().then(function () {
                        notificationService.showSuccess(doclrVertaal.instant('werkschema.wijzig.startdatum.succes'));
                    });
                }
            };

            $scope.verwijderWerkschema = function () {
                var modalInstance = openModalConfirmantionWindow({
                    title: doclrVertaal.instant('werkschema.verwijder.confirmmodal.title'),
                    question: doclrVertaal.instant('werkschema.verwijder.confirmmodal.question')
                });

                modalInstance.result.then(function () {
                    werkschemaModel.werkschema.verwijder()
                        .then(function () {
                                notificationService.showSuccess(doclrVertaal.instant('werkschema.verwijder.success'));
                                werkschemaOverzichtModel.reload();
                                $state.go('werkschema');
                            }
                        );
                });
            };

            $scope.copyWerkschema = function () {
                var modalInstance = $uibModal.open({
                    templateUrl: '/partials/werkschema/werkschema.nieuw.html',
                    controller: function ($scope, agendas) {
                        $scope.title = doclrVertaal.instant('werkschema.verwijder.copy.confirmmodal.titel');
                        $scope.form = {
                            agendas: agendas,
                            selectedAgenda: agendas.findAgendaVoorId(werkschemaModel.werkschema.id.substring(0, werkschemaModel.werkschema.id.indexOf('/werkschema'))),
                            vanaf: moment().format('YYYY-MM-DD')
                        };
                    },
                    resolve: {
                        agendas: function (AgendaOverzicht, praktijkContext) {
                            return AgendaOverzicht.get(praktijkContext.id);
                        }
                    }
                });

                modalInstance.result.then(function (form) {
                    werkschemaModel.werkschema.copy(form.selectedAgenda, form.vanaf)
                        .then(function (response) {
                                notificationService.showSuccess(doclrVertaal.instant('werkschema.copy.succes'));
                                werkschemaOverzichtModel.reload();
                                $state.go('werkschema.detail', {werkschemaId: encodeURIComponent(response.data.id)});
                            }
                        );
                });
            };

            $scope.verwijderWeek = function (week) {
                var modalInstance = openModalConfirmantionWindow({
                    title: doclrVertaal.instant('werkschema.remove.confirmmodal.titel'),
                    question: doclrVertaal.instant('werkschema.remove.confirmmodal.question')
                });

                modalInstance.result.then(function () {
                    var index = werkschemaModel.werkschema.weken.indexOf(week);
                    werkschemaModel.werkschema.weken.splice(index, 1);

                    var weekIndex = index === werkschemaModel.werkschema.weken.length ? werkschemaModel.werkschema.weken.length - 1 : index;

                    werkschemaModel.saveAndGoToWeek(weekIndex).then(function () {
                        notificationService.showSuccess(doclrVertaal.instant('werkschema.remove.week.title'));
                    });
                });
            };

            $scope.copyWeek = function (week) {
                var modalInstance = openModalConfirmantionWindow({
                    title: doclrVertaal.instant('werkschema.remove.week.title'),
                    question: doclrVertaal.instant('werkschema.remove.week.question')
                });

                modalInstance.result.then(function () {
                    werkschemaModel.werkschema.weken.push(angular.copy(week));

                    werkschemaModel.saveAndGoToWeek(werkschemaModel.werkschema.weken.length - 1).then(function () {
                        notificationService.showSuccess(doclrVertaal.instant('werkschema.remove.week.succes'));
                    });
                });
            };

            $scope.voegWeekToe = function () {
                var modalInstance = openModalConfirmantionWindow({
                    title: doclrVertaal.instant('werkschema.add.week.title'),
                    question: doclrVertaal.instant('werkschema.add.week.question')
                });

                modalInstance.result.then(function () {
                    werkschemaModel.werkschema.weken.push([]);

                    werkschemaModel.saveAndGoToWeek(werkschemaModel.werkschema.weken.length - 1).then(function () {
                        notificationService.showSuccess(doclrVertaal.instant('werkschema.add.week.succes'));
                    });
                });
            };

            $scope.rasterClicked = function rasterClicked(column, uur, event) {
                $scope.columnHeader = alsWeekdagFilter(column.header);
                $scope.column = column;
                $scope.uur = uur;
                $('.js-showable-dayclickedpopover').css({top: event.pageY, left: event.pageX});
                $('.js-showable-dayclickedpopover').popover('show');
            };

            $scope.isWerkschema = function () {
                return true;
            }

            $scope.invoeren = function invoeren() {
                $('.js-showable-dayclickedpopover').popover('hide');

                var beschikbaarheidToEdit = {
                    weekdag: $scope.column.header,
                    van: $scope.uur,
                    tot: null,
                    afspraakDuur: null,
                    aantalAfspraken: null,
                    releaseNumberOfDaysBefore: null,
                    releaseInOrderGroup: null,
                    releaseInOrderNumber: null,
                    type: null
                };

                $state.go('.beschikbaarheid', {
                    beschikbaarheidToEdit: beschikbaarheidToEdit,
                    intentie: 'nieuw'
                });
            };

            $scope.$on('closeAllPopoversUp', function () {
                $scope.$broadcast('closeAllPopoversDown');
            });
        })
        .controller('WerkschemaEventController', function ($scope, borderColor) {
            $scope.borderColor = borderColor;

            $scope.eventClicked = function eventClicked($event) {
                let isPopoverReleaseStrategy = $($event.target).hasClass('release-strategy-button');
                $scope.$emit('closeAllPopoversUp');
                if (isPopoverReleaseStrategy) {
                    $scope.popoverReleaseStrategyIsOpen = true;
                } else {
                    $scope.popoverIsOpen = true;
                }
            };

            $scope.releaseStrategyClicked = function eventClicked() {
                $scope.$emit('closeAllPopoversUp');
                $scope.popoverIsOpen = true;
            };


            $scope.popoverIsOpen = false;
            $scope.popoverReleaseStrategyIsOpen = false;
            $scope.dismissPopover = function dismissPopover() {
                $scope.popoverIsOpen = false;
                $scope.popoverReleaseStrategyIsOpen = false;
            };

            $scope.$on('closeAllPopoversDown', function () {
                $scope.dismissPopover();
            });
        })

        .controller('WerkschemaReleaseStrategyPopoverFormController', function ($scope, $state, notificationService) {

            $scope.availabilityReleaseStrategy = AvailabilityReleaseStrategy.createFromEvent($scope.event.releaseNumberOfDaysBefore, $scope.event.releaseInOrderNumber, $scope.event.releaseInOrderGroup)

            $scope.onReleaseStrategyConfirmed = function (strategy) {

                $scope.event.releaseInOrderGroup = strategy.inOrderRelease.getReleaseInOrderGroup();
                $scope.event.releaseInOrderNumber = strategy.inOrderRelease.getReleaseInOrderNumber();
                $scope.event.releaseNumberOfDaysBefore = strategy.timeBoundRelease.getReleaseNumberOfDaysBefore();

                $scope.event.releaseStrategy = strategy;
                $scope.dismissPopover();
                $scope.werkschemaModel.save().then(function () {
                    notificationService.showSuccess(doclrVertaal.instant('werkschema.strategy.changed'));
                    $scope.dismissPopover();
                });
            }
        })

        .controller('WerkschemaPopoverFormController', function ($scope, $state, notificationService) {
            $scope.wijzigen = function maakAfspraak() {
                $state.go('.beschikbaarheid', {beschikbaarheidToEdit: $scope.event, intentie: 'wijzigen'})
                    .then(function () {
                            $scope.dismissPopover();
                        }
                    );
            };

            $scope.verwijder = function verwijder() {
                $scope.werkschemaModel.verwijderBeschikbaarheid($scope.event);
                $scope.werkschemaModel.save().then(function () {
                    notificationService.showSuccess(doclrVertaal.instant('werkschema.remove.availability'));
                    $scope.dismissPopover();
                });
            };
        })

        // nieuwe agenda component
        // TODO: move to separate file
        .directive('agendaComponent', function (agendaDimensions) {
            return {
                restrict: 'A',
                templateUrl: '/partials/components/agenda.component.html',
                transclude: {
                    headerControls: 'headerControls',
                    columnHeaderTemplate: 'columnHeaderTemplate',
                    eventTemplate: 'eventTemplate'
                },
                scope: {
                    events: '=',
                    rasterClickedListener: '&'
                },
                controller: function ($scope, $attrs) {
                    var that = this;

                    function createGridModel(showEarlyHours, showLateHours, events) {
                        function isHeleDag(event) {
                            return event.van === '00:00' && event.tot === '24:00';
                        }

                        var startUur = 0;
                        if (!showEarlyHours) {
                            startUur = _.chain(events)
                                .pluck('events')
                                .flatten()
                                .reject(isHeleDag)
                                .pluck('van')
                                .map(function (van) {
                                    return parseInt(van.split(':')[0], 10);
                                })
                                .map(function (van) {
                                    return van - 1;
                                })
                                .union([8])
                                .min()
                                .value();
                        }

                        if (startUur < 0) {
                            startUur = 0;
                        }

                        var eindUur = 24;
                        if (!showLateHours) {
                            eindUur = _.chain(events)
                                .pluck('events')
                                .flatten()
                                .reject(isHeleDag)
                                .pluck('tot')
                                .map(function (tot) {
                                    return parseInt(tot.split(':')[0], 10);
                                })
                                .map(function (tot) {
                                    return tot + 1;
                                })
                                .union([17])
                                .max()
                                .value() + 1;
                        }

                        return {
                            startUur: startUur,
                            eindUur: eindUur,
                            pixelsPerUur: agendaDimensions.uurHoogte,
                            pixelsPerMinuut: agendaDimensions.uurHoogte / 60,
                            pixelsPerHourDivision: agendaDimensions.uurHoogte / agendaDimensions.hourDivisions.length,
                            hourDivisions: agendaDimensions.hourDivisions,
                            calculateTopInPixels: function (event) {
                                if (isHeleDag(event)) {
                                    return this.startUur;
                                }
                                var uren = parseInt(event.van.split(':')[0], 10);
                                var minuten = parseInt(event.van.split(':')[1], 10);
                                return ((uren - this.startUur) * this.pixelsPerUur) + (this.pixelsPerMinuut * minuten);
                            },
                            calculateHeightInPixels: function calculateHeight(event) {
                                var duur;
                                if (isHeleDag(event)) {
                                    duur = moment(this.eindUur, 'HH:mm').diff(moment(this.startUur, 'HH:mm'), 'minutes');
                                } else {
                                    duur = moment(event.tot, 'HH:mm').diff(moment(event.van, 'HH:mm'), 'minutes');
                                }
                                return this.pixelsPerMinuut * duur;
                            }
                        };
                    }

                    $scope.expandersEnabled = $attrs.hasOwnProperty('expandersEnabled');

                    $scope.showEarlyHours = false;
                    $scope.toggleShowEarlyHours = function toggleShowEarlyHours() {
                        $scope.showEarlyHours = !$scope.showEarlyHours;

                        that.gridModel = createGridModel($scope.showEarlyHours, $scope.showLateHours, $scope.events);
                        $scope.$broadcast('gridGewijzigd');
                    };

                    $scope.showEarlyHours = false;
                    $scope.toggleShowLateHours = function toggleShowLateHours() {
                        $scope.showLateHours = !$scope.showLateHours;

                        that.gridModel = createGridModel($scope.showEarlyHours, $scope.showLateHours, $scope.events);
                        $scope.$broadcast('gridGewijzigd');
                    };

                    this.gridModel = createGridModel($scope.showEarlyHours, $scope.showLateHours, $scope.events);

                    $scope.$watch('events', function (newVal, oldVal) {
                        if (newVal === oldVal) {
                            return;
                        }

                        that.gridModel = createGridModel($scope.showEarlyHours, $scope.showLateHours, $scope.events);
                        $scope.$broadcast('gridGewijzigd');
                    });

                    $scope.$on('rasterClicked', function (event, column, uur, clickEvent) {
                        $scope.rasterClickedListener({column: column, uur: uur, event: clickEvent});
                    });

                    this.closeAllPopovers = function closeAllPopovers() {
                        $scope.$broadcast('closeAllPopovers');
                    };
                }
            };
        })
        .directive('columnHeaderTemplateTransclude', function () {
            return {
                restrict: 'A',
                scope: {
                    column: '='
                },
                link: function (scope, element, attrs, controller, transclude) {
                    transclude(function (clone, tScope) {
                        tScope.column = scope.column;
                        element.append(clone);
                    }, undefined, 'columnHeaderTemplate');
                }
            };
        })
        .directive('headerControlsTransclude', function () {
            return {
                restrict: 'A',
                scope: {},
                link: function (scope, element, attrs, controller, transclude) {
                    transclude(function (clone, tScope) {
                        tScope.pusher = attrs.hasOwnProperty('pusher');
                        element.append(clone);
                    }, undefined, 'headerControls');
                }
            };
        })
        .directive('eventContainer', function () {
            return {
                restrict: 'A',
                require: '^agendaComponent',
                scope: {
                    event: '='
                },
                link: function (scope, element, attrs, agendaComponentController, transclude) {
                    transclude(function (clone, tScope) {
                        tScope.event = scope.event;
                        element.append(clone);
                    }, undefined, 'eventTemplate');

                    var gridModel = agendaComponentController.gridModel;

                    function ensureCorrectPosition(gridModel) {
                        element.css('top', gridModel.calculateTopInPixels(scope.event) + 'px');
                        element.css('height', gridModel.calculateHeightInPixels(scope.event) + 'px');
                        element.css('line-height', gridModel.calculateHeightInPixels(scope.event) + 'px');
                    }

                    ensureCorrectPosition(gridModel);

                    scope.$on('gridGewijzigd', function () {
                        ensureCorrectPosition(agendaComponentController.gridModel);
                    });
                }
            };
        })
        .directive('acRaster', function () {
            return {
                restrict: 'A',
                require: '^agendaComponent',
                scope: {
                    column: '='
                },
                link: function (scope, element, attrs, agendaComponentController) {
                    var gridModel = agendaComponentController.gridModel;

                    var outerDiv = element.append('<div></div>').children();

                    _.range(0, 24).forEach(function (uur) {
                        var hourDiv = outerDiv.append('<div></div>').children().last()
                            .addClass('agenda-dag-uur')
                            .addClass('agenda-dag-uur-' + uur)
                            .height(gridModel.pixelsPerUur);

                        if (attrs.hasOwnProperty('withUurLabels')) {
                            hourDiv.append('<div></div>').children().last()
                                .addClass('agenda-dag-uur-label')
                                .text(uur + ':00');
                        }

                        gridModel.hourDivisions.forEach(function (hourDivision) {
                            var hourDivisionDiv = hourDiv.append('<div></div>').children().last()
                                .addClass('agenda-dag-uur-division')
                                .css('height', gridModel.pixelsPerHourDivision);
                            if (scope.column) {
                                hourDivisionDiv.on('click', function (event) {
                                    var uurEnMinuten = moment({hour: uur}).add(hourDivision, 'minutes').format('HH:mm');
                                    scope.$emit('rasterClicked', scope.column, uurEnMinuten, event);
                                });
                            }
                        });

                    });

                    function ensureCorrectHoursAreShown(gridModel) {
                        element.find('.agenda-dag-uur').hide();

                        _.range(gridModel.startUur, gridModel.eindUur).forEach(function (uur) {
                            element.find('.agenda-dag-uur-' + uur).show();
                        });
                    }

                    ensureCorrectHoursAreShown(gridModel);

                    scope.$on('gridGewijzigd', function () {
                        ensureCorrectHoursAreShown(agendaComponentController.gridModel);
                    });
                }
            };
        })
        .filter('werkschemaToAgendaEvents', function () {
            return function (werkschema, weekIndex) {
                // TODO meer functioneel maken...
                var result = _.chain(werkschema.weken[weekIndex])
                    .groupBy('weekdag')
                    .map(function (value, key) {
                        return {header: parseInt(key), events: value};
                    })
                    .value();

                // ensure all weekdays present
                _.chain(_.range(1, 8)).difference(_.pluck(result, 'header')).each(function (missing) {
                    result.push({header: missing, events: []});
                });

                return _.sortBy(result, 'header');
            };
        })
        .filter('alsWeekdag', function () {
            return function (oneBasedWeekdagIndex) {
                return moment().weekday(oneBasedWeekdagIndex - 1).format('dddd');
            };
        })
        .filter('expiredWerkschemas', function () {
            return function (werkschemas, doFilter) {
                if (doFilter) {
                    return _.reject(werkschemas, function (werkschema) {
                        return moment(werkschema.vanaf).isBefore(moment()) && moment(werkschema.tot).isBefore(moment());
                    });
                } else {
                    return werkschemas;
                }
            };
        });
})();